import React, { Component } from 'react'
import Helmet from 'react-helmet'

import ogImage from '../../assets/images/og-image.png';

class MetaTags extends Component {
	
    render() {
        const { title, description, image, url, noPrefix } = this.props;
        const titlePrefix = noPrefix ? '' : 'UIOLI – '  
		
        return (
            <Helmet>
                <meta name="og:image" content={'http://admin.orlose.it/wp-content/uploads/ogImage.png'} />
                <meta name="description" content={'Use It Or Lose It is a grassroots advocacy campaign for creative professionals which seeks to enable positive, educational, and mutually beneficial conversations around the subject of usage fees and licensing.'} />

                {title && (
                    <title>{titlePrefix + title}</title>
                )}
                {title && (
                    <meta name="og:title" content={titlePrefix + title} />
                )}
                {description && (
                    <meta name="description" content={description && description.replace(/<\/?[^>]+(>|$)/g, "")} />
                )}
                {description && (
                   <meta name="og:description" content={description && description.replace(/<\/?[^>]+(>|$)/g, "")} />
                )}
            </Helmet>
        )
    }
}

export default MetaTags 


// WEBPACK FOOTER //
// ./client/components/MetaTags/MetaTags.js